import type {
  FeedbackFormStatus,
  FeedbackFormTemplateChoice,
  FeedbackFormTriggerType,
} from '@gto/api-client/admin/react-query'
import type { FeedbackQuestionType } from '@gto/feedback-ui'

/**
 * Staff-facing names. Kept out of i18n because admin-web is English-only staff
 * tooling — see apps/admin-web/README.md.
 */
export const QUESTION_TYPE_LABEL: Record<FeedbackQuestionType, string> = {
  face_rating: '3-face rating',
  star_rating: '5-star rating',
  nps: 'NPS, 0 to 10',
  agreement: 'Agreement, 1 to 7',
  yes_no: 'Yes or no',
  single_choice: 'Single choice',
  multiple_choice: 'Multiple choice',
  open_text: 'Open text',
}

export const STATUS_LABEL: Record<FeedbackFormStatus, string> = {
  draft: 'Draft',
  live: 'Live',
  paused: 'Paused',
  ended: 'Ended',
}

export const TEMPLATE_LABEL: Record<FeedbackFormTemplateChoice, string> = {
  feature_rating: 'Feature rating',
  new_feature_check_in: 'New feature check-in',
  flow_ease: 'Flow ease',
  nps: 'NPS',
  blank: 'Blank',
}

export const TRIGGER_TYPE_LABEL: Record<FeedbackFormTriggerType, string> = {
  page: 'On a page',
  event: 'After an analytics event',
}

/** The statuses in the order the list filter offers them, widest use first. */
export const STATUS_CHOICES = [
  'live',
  'draft',
  'paused',
  'ended',
] as const satisfies readonly FeedbackFormStatus[]
